export const pointsToRemainInTier = ({ loyalty }) => {
  if (loyalty.tier.pointsToRemainInTier === null) return 0;
  return Math.max(0, loyalty.tier.pointsToRemainInTier - loyalty.statusPoints);
};
